import React, { useState } from 'react';
import './Login.scss';
import LoginForm from '../../components/LoginForm/LoginForm'
import {API_URL} from '../../utils/axios'
import axios from 'axios'
import { Redirect } from 'react-router-dom';
import {Link} from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("");

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(API_URL + '/user/login', {
           email,
           password 
        }).then((response) => {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("name", response.data.name);
            window.location = "/menu"
        }).catch(error => console.log(error))
    }

    if(localStorage.getItem("token")) {
        return <Redirect to="/menu"/>
    }
    return (
        <div className="login">
            <div className="login__left">
                <span className="login__food">Food</span>
                <span className="login__r">r</span>
            </div>
            <div className="login__right">
                < LoginForm email={email} password={password}
                handleEmailChange={handleEmailChange}
                handlePasswordChange={handlePasswordChange}
                handleSubmit={handleSubmit}
                />
                <div className="login__alternative-options">
                    <Link to="/createaccount" className="login__create-account">Create Your Account →</Link>
                </div>
            </div>
        </div>

    );
};

export default Login;